/* eslint-disable no-nested-ternary */
import UAParser from 'ua-parser-js';

const appStoreLink = 'https://apps.apple.com/app/timeless-collectibles/id1525379976';
const playStoreLink = 'https://play.google.com/store/apps/details?id=com.timeless.investments.app';
const webLink = 'https:///www.timeless.investments';

// links with specific targets
// this should be moved to a database table with a config UI at some point
const specificTargets = {
  '/app-store': appStoreLink,
  '/play-store': playStoreLink,
};

function gatherInfos() {
  const parser = new UAParser();
  const device = parser.getDevice();
  const os = parser.getOS();
  const cpuCores = navigator.hardwareConcurrency;
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const { pixelDepth } = window.screen;
  const { languages } = navigator;
  const { language } = navigator;
  const connectionType: string | null = navigator?.['connection']?.effectiveType ?? null;

  return {
    deviceType: device.type,
    deviceVendor: device.vendor,
    deviceModel: device.model,
    osName: os.name,
    // osVersion: os.version,
    screenResolution,
    pixelDepth,
    cpuCores,
    languages,
    language,
    connectionType,
  };
}

function gatherParams() {
  const url = new URL(window.location.href);
  return {
    pathname: url.pathname,
    postLocal: url.searchParams.get('postLocal'),
    _d: url.searchParams.get('_d'),
    relevantParams: {
      utmSource: url.searchParams.get('utm_source'),
      utmCampaign: url.searchParams.get('utm_campaign'),
      utmMedium: url.searchParams.get('utm_medium'),
      utmContent: url.searchParams.get('utm_content'),
      ref: url.searchParams.get('ref'),
      target: url.searchParams.get('target'),
      fbclid: url.searchParams.get('fbclid'),
      gclid: url.searchParams.get('gclid'),
      ttclid: url.searchParams.get('ttclid'),
    },
  };
}

function getWebUrlWithParams(pathname: string, params: Record<string, string>) {
  if (pathname.includes('/r/')) {
    pathname = pathname.replace('/r/', '/');
  }

  const url = new URL(webLink + pathname);
  const searchParams = new URLSearchParams(Object.entries(params).filter((keyValuePair) => Boolean(keyValuePair[1])));
  url.search = searchParams.toString();
  return url.toString();
}

function sendInfos() {
  const paramsData = gatherParams();

  const infos = gatherInfos();

  const payload = { ...infos, ...paramsData.relevantParams };

  function getDynamicTarget() {
    return infos.osName?.toLowerCase() === 'ios'
      ? appStoreLink
      : infos.osName?.toLowerCase() === 'android'
        ? playStoreLink
        : getWebUrlWithParams(paramsData.pathname, paramsData.relevantParams as any);
  }

  const redirectTarget = specificTargets[paramsData.pathname] ?? getDynamicTarget();

  const redirectMessageElement = document.getElementById('redirect-message');
  const rootElement = document.getElementById('root');
  const redirectButtonElement = document.getElementById('goto-timeless');
  const closeButtonElement = document.getElementById('close');

  redirectButtonElement?.setAttribute('href', redirectTarget);

  const browserLanguage = navigator.language;
  const isEnglish = !browserLanguage.startsWith('de');

  if (isEnglish) {
    if (redirectButtonElement) {
      redirectButtonElement.innerHTML = 'Go to Timeless';
    }

    if (closeButtonElement) {
      closeButtonElement.innerHTML = 'Close';
    }

    if (redirectMessageElement) {
      redirectMessageElement.innerHTML = 'You are being redirected to Timeless';
    }
  }

  if (paramsData._d === '1') {
    const debugElement = document.createElement('pre');
    debugElement.innerHTML = JSON.stringify({ redirectTarget }, null, 2);
    debugElement.style.whiteSpace = 'pre-wrap';
    debugElement.style.padding = '20px';
    debugElement.style.fontFamily = 'monospace';
    debugElement.style.textAlign = 'left';

    rootElement?.replaceChildren(debugElement);
  } else if (paramsData.postLocal) {
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify(infos));
  } else {
    // eslint-disable-next-line
    fetch('/api/session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    }).finally(() => {
      rootElement?.classList.add('redirect-done');
      window.location.href = redirectTarget;
    });
  }
}

sendInfos();
